import { getFoldersResponseSchema } from "@mg/schemas/src/christo/catalyst";
import { isMongoId } from "validator";
import { z } from "zod";

import { API_URL } from "../config/env";
import { smartFetch } from "../utils/http";
import { parseResponse } from "../utils/parseResponse";

const reviewTicketParser = z.object({
  _id: z.string().refine((val) => isMongoId(val)),
  name: z.string(),
  thumbnail: z.string(),
});

const reviewResultParser = z.object({
  tickets: z.array(reviewTicketParser),
  personas: z.array(z.enum(["copy", "brand", "legal"])),
  createdAt: z.string().datetime(),
  summary: z.string(),
});

const reviewParser = z.object({
  _id: z.string().refine((val) => isMongoId(val)),
  name: z.string(),
  results: z.array(reviewResultParser),
});

export type Review = z.infer<typeof reviewParser>;

export const getWorkflowReviewsResponseParser = z.array(reviewParser);

export async function getRecentReviews(params?: {
  query?: string;
  limit?: string;
  folderId?: string;
}) {
  const queryString = params
    ? new URLSearchParams(
        Object.fromEntries(
          Object.entries(params).filter(([_, value]) => value !== undefined),
        ),
      ).toString()
    : undefined;
  const json = await smartFetch(
    `${API_URL}/private/catalyst/reviews/recents?${queryString}`,
    {
      method: "GET",
    },
  );

  const parsedData = parseResponse(getFoldersResponseSchema, json);
  return parsedData;
}

export async function rateTicket(ticketId: string, rating: number) {
  const json = await smartFetch(
    `${API_URL}/private/catalyst/tickets/${ticketId}/rate?rating=${rating}`,
    {
      method: "POST",
    },
  );

  return json;
}
